
 /**
 * Event `MultiScene.ChangeView`
 *
 * @typedef {Object} MultSceneForApp~MultiScene~Events~ChangeView
 * @property {string} type - type of event, has value `multiscene.changeview`
 * @property {Array} position - position of camera
 * @property {Array} rotation - rotation of camera
 */

export default function createEventChangeView(position, rotation) {
    return {
        type: 'multiscene.changeview',
        position: position,
        rotation: rotation
    };
}
